export default __webpack_public_path__ + "static/media/delete_device_config.b7faf65d.svg";